/**
 * Copy + config for the web promo-banner sequence (invite → Discord).
 *
 * A small, precedence-ordered growth surface shown one banner at a time at the
 * top of the lobby / in-game main view. Web only. The pure precedence logic
 * lives in apps/web/src/lib/promo-banner-state.ts; this module is just the
 * player-facing strings + PM amounts (imported, never duplicated).
 */

import { DISCORD_JOIN_GRANT_PM, REFERRAL_GRANT_PM } from './billing.js';

/** Banner identifiers, in precedence order. */
export type PromoBannerKind = 'invite' | 'discord';

export const PROMO_BANNER_COPY = {
  invite: {
    emoji: '🎁',
    title: 'Invite a friend',
    body: `You both get extra ${REFERRAL_GRANT_PM} PM tokens to play.`,
    cta: 'Invite a friend',
    learnMoreHref: '/multiplayer',
    learnMoreLabel: 'Learn more...',
  },
  discord: {
    emoji: '💬',
    title: 'Join our Discord',
    body: `Join our Discord for a ${DISCORD_JOIN_GRANT_PM} PM token award, and share beta feedback there to earn even more`,
    primaryCta: 'Join our Discord',
    secondaryCta: 'Claim your tokens',
  },
} as const;
